module.exports = "pegasus_template/assets/column-14-basic.png";